module.exports = __webpack_public_path__ + "img/customer-img.9b6e9e25.png";